var selectors = {
	scrollSection: '.js-scroll-filter-wrapper',
	scrollContainer: '.js-scrolling-filters',
	leftArrow: '.js-scrolling-filters-arrow-left',
	rightArrow: '.js-scrolling-filters-arrow-right'
}

let $scrollSection;
let $scrollContainer;
let $leftArrow;
let $rightArrow;

var module = {
	init: function () {
		module._initElement();
		module._bindEvents();
		module._updateArrowVisibility();
		window.addEventListener('resize', module._updateArrowVisibility);
	},

	_initElement: function () {
		$scrollSection = document.querySelector(selectors.scrollSection);
		$scrollContainer = document.querySelector(selectors.scrollContainer);
		$leftArrow = document.querySelector(selectors.leftArrow);
		$rightArrow = document.querySelector(selectors.rightArrow);
	},

	_bindEvents: function () {
		const scrollAmount = 100; // pixels per click

		$leftArrow.addEventListener('click', () => {
			$scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
		});

		$rightArrow.addEventListener('click', () => {
			$scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		});
	},

	_updateArrowVisibility: function () {
		if (!$scrollContainer || !$leftArrow || !$rightArrow) return;
		if ($scrollContainer.scrollWidth > $scrollContainer.clientWidth) {
			$leftArrow.style.display = '';
			$rightArrow.style.display = '';
			$scrollSection.style.paddingBottom = '80px';
		} else {
			$leftArrow.style.display = 'none';
			$rightArrow.style.display = 'none';
			$scrollSection.style.paddingBottom = '20px';

		}
	}
}

export { module as ScrollFilter };
